export const backgroundQuestions = [
  // Contact Information
  {
    id: 'contact',
    title: 'Contact Information',
    questions: [
      {
        id: 'name',
        text: 'Full Name:',
        type: 'text'
      },
      {
        id: 'email',
        text: 'Email Address:',
        type: 'email'
      },
      {
        id: 'preferredCommunication',
        text: 'Preferred means of communication:',
        type: 'dropdown',
        options: ['Email', 'Phone', 'Text message', 'In-person', 'Video call']
      }
    ]
  },
  
  // Demographics
  {
    id: 'demographics',
    title: 'Demographics',
    questions: [
      {
        id: 'classLevel',
        text: 'What is your class level?',
        type: 'dropdown',
        options: ['Freshman', 'Sophomore', 'Junior', 'Senior', 'Graduate']
      },
      {
        id: 'hometown',
        text: 'Hometown/Country:',
        type: 'text'
      },
      {
        id: 'classCount',
        text: 'How many classes are you taking this term?',
        type: 'number'
      },
      {
        id: 'majorCount',
        text: 'How many majors do you plan to complete? (Do not count minors.)',
        type: 'dropdown',
        options: ['One', 'More than one']
      },
      {
        id: 'major',
        text: 'Please enter your major or expected major:',
        type: 'text',
        conditional: { field: 'majorCount', value: 'One' }
      },
      {
        id: 'majors',
        text: 'Please enter up to two majors or expected majors (do not enter minors):',
        type: 'textarea',
        conditional: { field: 'majorCount', value: 'More than one' }
      }
    ]
  },
  
  // Language Proficiency
  {
    id: 'language',
    title: 'Language Proficiency',
    questions: [
      {
        id: 'firstLanguage',
        text: 'What is your first language?',
        type: 'text'
      },
      {
        id: 'dailyLanguage',
        text: 'Which language do you use most frequently in your daily life?',
        type: 'text'
      },
      {
        id: 'englishProficiency',
        text: 'Overall, how would you rate your proficiency in English?',
        type: 'radio',
        options: [
          { value: 1, label: 'Not proficient at all' },
          { value: 2, label: 'Basic proficiency' },
          { value: 3, label: 'Intermediate proficiency' },
          { value: 4, label: 'Advanced proficiency' },
          { value: 5, label: 'Native-like proficiency' }
        ]
      },
      {
        id: 'speakingComfort',
        text: 'How comfortable do you feel speaking English in a conversation?',
        type: 'radio',
        options: [
          { value: 1, label: 'Not comfortable at all' },
          { value: 2, label: 'Slightly comfortable' },
          { value: 3, label: 'Moderately comfortable' },
          { value: 4, label: 'Very comfortable' },
          { value: 5, label: 'Extremely comfortable' }
        ]
      },
      {
        id: 'listeningSkill',
        text: 'How well do you understand spoken English (e.g., conversations, lectures, etc.)?',
        type: 'radio',
        options: [
          { value: 1, label: 'Very poorly' },
          { value: 2, label: 'Poorly' },
          { value: 3, label: 'Somewhat well' },
          { value: 4, label: 'Well' },
          { value: 5, label: 'Very well' }
        ]
      },
      {
        id: 'readingComfort',
        text: 'How comfortable are you with reading texts (e.g., books, articles) in English?',
        type: 'radio',
        options: [
          { value: 1, label: 'Very uncomfortable' },
          { value: 2, label: 'Uncomfortable' },
          { value: 3, label: 'Neutral' },
          { value: 4, label: 'Comfortable' },
          { value: 5, label: 'Very comfortable' }
        ]
      },
      {
        id: 'writingAbility',
        text: 'Rate your ability to write in English (e.g., essays, emails, messages).',
        type: 'radio',
        options: [
          { value: 1, label: 'Very poor' },
          { value: 2, label: 'Poor' },
          { value: 3, label: 'Average' },
          { value: 4, label: 'Good' },
          { value: 5, label: 'Excellent' }
        ]
      }
    ]
  },

  // Previous School Background
  {
    id: 'schoolBackground',
    title: 'Previous School Background',
    questions: [
      {
        id: 'courseworkEmphasis',
        text: 'During your most recent school year, how much has your coursework emphasized the following?',
        type: 'group',
        subQuestions: [
          {
            id: 'memorizing',
            text: 'Memorizing course material',
            type: 'radio',
            options: ['Not at all', 'Very little', 'Some', 'Quite a bit', 'Very much']
          },
          {
            id: 'applying',
            text: 'Applying facts, theories, or methods to practical problems or new situations',
            type: 'radio',
            options: ['Not at all', 'Very little', 'Some', 'Quite a bit', 'Very much']
          },
          {
            id: 'analyzing',
            text: 'Analyzing an idea, experience, or line of reasoning in depth by examining its parts',
            type: 'radio',
            options: ['Not at all', 'Very little', 'Some', 'Quite a bit', 'Very much']
          },
          {
            id: 'evaluating',
            text: 'Evaluating a point of view, decision, or information source',
            type: 'radio',
            options: ['Not at all', 'Very little', 'Some', 'Quite a bit', 'Very much']
          },
          {
            id: 'forming',
            text: 'Forming a new idea or understanding from various pieces of information',
            type: 'radio',
            options: ['Not at all', 'Very little', 'Some', 'Quite a bit', 'Very much']
          }
        ]
      },
      {
        id: 'numericalTasks',
        text: 'During the most recent school year, about how often have you done the following?',
        type: 'group',
        subQuestions: [
          {
            id: 'numericalAnalysis',
            text: 'Reached conclusions based on your own analysis of numerical information (numbers, graphs, statistics, etc.)',
            type: 'radio',
            options: ['Never', 'Rarely', 'Sometimes', 'Often', 'Very often']
          },
          {
            id: 'numericalProblems',
            text: 'Used numerical information to examine a real-world problem or issue (unemployment, climate change, public health, etc.)',
            type: 'radio',
            options: ['Never', 'Rarely', 'Sometimes', 'Often', 'Very often']
          },
          {
            id: 'evaluatingNumerical',
            text: 'Evaluated what others have concluded from numerical information',
            type: 'radio',
            options: ['Never', 'Rarely', 'Sometimes', 'Often', 'Very often']
          }
        ]
      },
      {
        id: 'writingTasks',
        text: 'During the most recent school year, about how many papers, reports, or other writing tasks of the following lengths have you been assigned? (Include those not yet completed.)',
        type: 'group',
        subQuestions: [
          {
            id: 'papers5Pages',
            text: 'Up to 5 pages',
            type: 'radio',
            options: ['None', '1-2', '3-5', '6-10', '11-15', '16-20', 'More than 20 papers']
          },
          {
            id: 'papers6to10Pages',
            text: 'Between 6 and 10 pages',
            type: 'radio',
            options: ['None', '1-2', '3-5', '6-10', '11-15', '16-20', 'More than 20 papers']
          },
          {
            id: 'papers11Plus',
            text: '11 pages or more',
            type: 'radio',
            options: ['None', '1-2', '3-5', '6-10', '11-15', '16-20', 'More than 20 papers']
          }
        ]
      }
    ]
  },

  // Course Specific Background
  {
    id: 'courseBackground',
    title: 'Course Specific Background',
    questions: [
      {
        id: 'selectedCourse',
        text: 'Select the course you want to answer about:',
        type: 'course_dropdown'
      },
      {
        id: 'previousCourses',
        text: 'How many college courses have you had in this subject area?',
        type: 'number'
      },
      {
        id: 'reasonsForTaking',
        text: 'Reasons for taking this class: (Select up to three)',
        type: 'checkbox',
        options: [
          'Content seems interesting',
          'Is required for all students in the university',
          'Will be useful to me in other courses',
          'Is an easy elective',
          'Will help me improve my academic skills',
          'Is required for major (program)',
          'Was recommended by a friend',
          'Was recommended by an advisor/faculty',
          'Will improve career prospects',
          'Fits into my schedule'
        ]
      }
    ]
  }
];